// components/WhatWeDoSection.jsx
import SectionReveal from './SectionReveal';
import wathwedoimg from '../assets/wathwedo.png'
export default function WhatWeDoSection({ t }) {
  const services = t?.whatWeDoServices || [
    'Համայնքային կեղտաջրերի մաքրման համակարգեր',
    'Արդյունաբերական կեղտաջրերի մաքրում',
    'Խմելու ջրի մաքրման համակարգեր',
    'Տեղային կենսաբանական մաքրման կայաններ',
    'Ջրի վերաօգտագործման լուծումներ',
    'Ժամանակակից հանրային սանիտարական համակարգեր',
    'Ինժեներական նախագծում և տեխնիկական խորհրդատվություն',
    'Սարքավորումների մատակարարում, տեղադրում և սպասարկում'
  ];
  return (
    <section id="what-we-do" className="relative bg-white px-3 py-20 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Блок 1: Чем занимаемся + фото справа */}
        <SectionReveal>
          <div className="md:border-l-4 border-l-2 p-3 border-[#0FA4E8] overflow-hidden">
            <div className="grid md:grid-cols-5">
               {/* Правая часть - фото */}
              <div className="md:col-span-2 relative min-h-[300px] overflow-hidden">
                <img 
                  src={wathwedoimg} 
                  alt="Water treatment"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#0B3B6F]/10" />
              </div>
              {/* Левая часть - список */}
              <div className="md:col-span-3 bg-gray-50 p-3 md:p-10">
                <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-2">
                  {t?.whatWeDoTitle || 'Ինչով ենք զբաղվում'}
                </h2>
                <p className="text-sm text-slate-500 mb-6">
                  {t?.whatWeDoIntro || 'NWTA-ն իրականացնում է ամբողջական ինժեներական նախագծեր՝'}
                </p>
                
                <div className="grid gap-2 sm:grid-cols-2">
                  {services.map((service, idx) => (
                    <div 
                      key={idx}
                      className="flex items-start gap-3 p-3 hover:bg-white transition-colors group"
                    >
                      <span className="flex-shrink-0 text-[#0FA4E8] mt-0.5">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </span>
                      <span className="text-sm font-medium text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors leading-tight">
                        {service}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </SectionReveal>

        {/* Блок 2: Цель + Миссия */}
        <div className="grid gap-8 p-3 md:grid-cols-2">
          
          <SectionReveal delay={150}>
            <div className=" bg-[#0FA4E8]/5 p-3 md:p-10 h-full">
              <h3 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-3">
                {t?.whatWeDoGoalTitle || 'Մեր նպատակը պարզ է՝'}
              </h3>
              <p className="text-lg font-bold text-[#0B3B6F] leading-relaxed">
                {t?.whatWeDoGoalText || 'Ստեղծել ավելի մաքուր, անվտանգ և տեխնոլոգիապես զարգացած Հայաստան՝ ժամանակակից ջրային լուծումների միջոցով։'}
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={300}>
            <div className=" bg-[#0FA4E8]/5 p-3 md:p-10 h-full ">
              <h3 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-3">
                {t?.whatWeDoMissionTitle || 'Մեր առաքելությունը'}
              </h3>
              <p className="text-lg font-bold text-[#0B3B6F] leading-relaxed">
                {t?.whatWeDoMissionText || 'Ստեղծել ժամանակակից, հուսալի և կայուն ջրային լուծումներ, որոնք կբարելավեն մարդկանց կյանքի որակը, կպաշտպանեն բնական ռեսուրսները և կնպաստեն Հայաստանի տնտեսական ու բնապահպանական զարգացմանը։'}
              </p>
            </div>
          </SectionReveal>

        </div>

      </div>
    </section>
  );
}